import { IEnumLangBuilder } from '@guibil/app';
import { AuthEnumTypes } from '../auth-enum';
import { auth_user_gender_tr } from '../user/gender/locales/tr_TR';
import { auth_user_role_tr } from '../user/role/locales/tr_TR';

export const auth_enum_tr: IEnumLangBuilder<AuthEnumTypes> = {
  AuthUserGender: auth_user_gender_tr,
  AuthUserRole: auth_user_role_tr,
};
